import { EDUGATE_API_URL } from '../config/serviceConfig'

export async function isChatlogMarkdownLike(file) {
  const text = await file.text()
  const lines = text.replace(/^\uFEFF/, '').split(/\r?\n/)
  const roleBlocks = []
  let inFence = false
  let fenceMarker = ''
  for (const line of lines) {
    const trimmed = line.trim()
    if (trimmed.startsWith('```') || trimmed.startsWith('~~~')) {
      const marker = trimmed.slice(0, 3)
      if (!inFence) {
        inFence = true
        fenceMarker = marker
      } else if (marker === fenceMarker) {
        inFence = false
        fenceMarker = ''
      }
    }
    if (inFence) continue
    const match = line.match(/^##\s+(User|Assistant)\s*$/) || line.match(/^\*\*(User|Assistant)\*\*\s*$/)
    if (match) roleBlocks.push(match[1])
  }
  if (roleBlocks.length === 0) return '未找到顶格的 User / Assistant 角色标题（## User 或 **User**）'
  if (!roleBlocks.includes('User') || !roleBlocks.includes('Assistant')) return '必须同时包含 User 和 Assistant 消息'
  return ''
}

export async function submitChatlogFiles({
  trainingTaskId,
  studentId,
  ide,
  files,
  submitMessage = '',
  headers = {},
}) {
  if (!trainingTaskId) throw new Error('作业 ID 缺失，请选择要提交的作业')
  if (!files?.length) throw new Error('请先准备 ChatLogs 文件')
  const formData = new FormData()
  formData.append('trainingTaskId', String(trainingTaskId))
  formData.append('homeworkId', String(trainingTaskId))
  formData.append('ide', ide || 'trae')
  formData.append('submitMessage', submitMessage || '')
  if (studentId) formData.append('studentId', String(studentId))
  files.forEach((file) => formData.append('files', file))
  const response = await fetch(`${EDUGATE_API_URL}/api/chatlogs/submit`, {
    method: 'POST',
    headers,
    body: formData,
  })
  const data = await response.json()
  if (data.code !== 0) throw new Error(data.message || '提交失败')
  return data
}
